import React from 'react';

const PageParentContext = React.createContext({
  pageChildType: void 0,
  pageParentType: void 0,
  pageParentId: void 0,
});

export { PageParentContext };
